import { useState } from "react";
import { LuEye, LuEyeClosed } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import methodModel from "../methods";
import loader from "../loader";
import ApiClient from "../api/apiClient";
import { toast } from "react-toastify";
import environment from "../../environment";

export default function Signup() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmpassword: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [eyes, setEyes] = useState({
    password: false,
    confirmpassword: false,
  });
  const navigate = useNavigate();

  const isValidEmail = form.email.trim() ? methodModel.emailvalidation(form.email.trim()) : false;
  const isValidPassword = form.password ? methodModel.passwordValidation(form.password) : false;

  const isFormValid = () => {
    return (
      form.firstName.trim() !== "" &&
      form.lastName.trim() !== "" &&
      form.email.trim() !== "" &&
      isValidEmail &&
      form.password !== "" &&
      isValidPassword &&
      form.confirmpassword !== "" &&
      form.password === form.confirmpassword
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (!isFormValid()) {
      return;
    }

    let payload = {
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      email: form.email.trim(),
      password: form.password,
      confirmpassword: form.confirmpassword,
      role: environment.user_role_id,
    };

    loader(true);
    ApiClient.post(`user/register`, payload)
      .then((res) => {
        if (res && res.success) {
          swal({
            icon: "success",
            title: "Success!",
            text: res.message || "Account created successfully!",
            confirmButtonColor: "#115B9D",
            timerProgressBar: true,
          }).then(() => {
            navigate("/login");
          });
        }
      })
      .catch((err) => {
        console.error("Signup error:", err);
      })
      .finally(() => {
        loader(false);
      });
  };

  return (
    <>
      <div
        className="h-screen overflow-auto flex !bg-bottom !bg-cover !bg-no-repeat p-5"
        style={{ background: "url('assets/img/auth-bg.webp')" }}
      >
        <div className="w-full m-auto">
          <div className="auth-page grid grid-cols-12 gap-3 max-w-[500px] md:max-w-[900px] w-full rounded-[20px] bg-white sm:px-10 p-5 py-10 mx-auto relative">
            <div className="col-span-5 max-md:hidden">
              <div className="flex flex-col gap-y-[6rem] justify-between h-full">
                <Link to="/">
                  <img
                    src="/assets/img/logo.png"
                    className="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto"
                    alt="Logo"
                  />
                </Link>
                <div className="relative top-[10px]">
                  <img
                    src="/assets/img/auth-left-img.png"
                    className="w-full h-full object-contain scale-[1.6]"
                    alt="Auth illustration"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-7 flex h-full items-center md:ml-[4rem] z-10">
              <form onSubmit={handleSubmit} noValidate className="w-full">
                <div className="space-y-3">
                  <img
                    src="/assets/img/circle-2.png"
                    className="w-[125px] h-[125px] object-contain absolute right-5 top-0"
                    alt="Decoration"
                  />
                  <img
                    src="/assets/img/logo.png"
                    className="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto md:hidden"
                    alt="Logo"
                  />
                  <div className="space-y-1">
                    <h3 className="text-2xl text-[#414141] text-center font-semibold">
                      Signup
                    </h3>
                  </div>
                  <p className="text-sm text-center text-[#737373]">
                    Enter your details to create your account.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4 mt-7">
                  {/* First Name */}
                  <div className="col-span-2 sm:col-span-1 w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="John"
                        value={form.firstName}
                        onChange={(e) =>
                          setForm({ ...form, firstName: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4"
                      />
                    </div>
                    {submitted && !form.firstName.trim() && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">First name is required</span>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="col-span-2 sm:col-span-1 w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Doe"
                        value={form.lastName}
                        onChange={(e) =>
                          setForm({ ...form, lastName: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4"
                      />
                    </div>
                    {submitted && !form.lastName.trim() && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">Last name is required</span>
                    )}
                  </div>

                  {/* Email Address */}
                  <div className="col-span-2 w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        placeholder="name@example.com"
                        value={form.email}
                        onChange={(e) =>
                          setForm({ ...form, email: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4"
                      />
                    </div>
                    {submitted && !form.email.trim() && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">Email address is required</span>
                    )}
                    {submitted && form.email.trim() && !isValidEmail && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">Please enter a valid email address</span>
                    )}
                  </div>

                  {/* Password */}
                  <div className="col-span-2 sm:col-span-1 w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type={eyes.password ? "text" : "password"}
                        placeholder="••••••••"
                        value={form.password}
                        onChange={(e) =>
                          setForm({ ...form, password: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {!eyes.password ? (
                        <LuEyeClosed
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              password: !eyes.password,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEye
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              password: !eyes.password,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                    </div>
                    {submitted && !form.password && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">Password is required</span>
                    )}
                    {submitted && form.password && !isValidPassword && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">
                        {methodModel.passwordValidationMessages(form.password)}
                      </span>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div className="col-span-2 sm:col-span-1 w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Confirm Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type={eyes.confirmpassword ? "text" : "password"}
                        placeholder="••••••••"
                        value={form.confirmpassword}
                        onChange={(e) =>
                          setForm({ ...form, confirmpassword: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {!eyes.confirmpassword ? (
                        <LuEyeClosed
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              confirmpassword: !eyes.confirmpassword,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEye
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              confirmpassword: !eyes.confirmpassword,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                    </div>
                    {submitted && !form.confirmpassword && (
                      <span role="alert" className="text-xs text-[#c53030] mt-1 block">
                        Confirm password is required
                      </span>
                    )}
                    {submitted &&
                      form.confirmpassword &&
                      form.password !== form.confirmpassword && (
                        <span role="alert" className="text-xs text-[#c53030] mt-1 block">
                          Passwords do not match
                        </span>
                      )}
                  </div>
                </div>

                <div className="mt-8">
                  <button
                    type="submit"
                    className="bg-[linear-gradient(45deg,#115B9D,#062037)] w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] !px-4 cursor-pointer"
                  >
                    Signup
                  </button>
                </div>

                <div className="flex gap-1 justify-center mt-5">
                  <p className="text-sm text-[#737373]">
                    Already have an account?
                  </p>
                  <Link
                    to="/login"
                    className="text-sm font-semibold text-[#115B9D] cursor-pointer hover:opacity-80"
                  >
                    Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
